module.exports = __webpack_public_path__ + "static/img/COC2021-30.34d0709.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-30.jpg
// module id = 0hxV
// module chunks = 0